<div in:AnimIN out:AnimOUT>
    <button class:ready={!!ready} class="caption" style="background-position-y:{ready*100/8}%;" on:click>Nākamo jautājumu!</button>
</div>

<style>
button {
    font-size: 2em;
    padding: 0.5em 1.5em;
    border-radius: 2em;
    border: none;
    background: linear-gradient(0deg, var(--yotta), var(--zetta), var(--exa), var(--peta), var(--tera), var(--giga), var(--mega), var(--kilo),
                                      var(--kilo), var(--mega), var(--giga), var(--tera), var(--peta), var(--giga), var(--zetta), var(--yotta));
    background-size: 100% 1600%;
    background-position-y: 0%;
    cursor: pointer;
    box-shadow: var(--tera-shadow);
    animation: wobble-hor-bottom 3s infinite both;
    color: white;
    transition: background-position-y 500ms ease-out;
}
@keyframes wobble-hor-bottom {
    0% { transform: scale(1); }
    50% { transform: scale(0.95); }
    100% { transform: scale(1); }
}
</style>

<script>
import { AnimIN, AnimOUT } from "../../code/anim.js"

export let ready // atgriež number ar reizēm cik esi nospiedis uz pogas
</script>